var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { CaptureService } from '@/services';
import { setCachedQueryAnswer, useQuestionnaire } from '@/store';
import { CachedQueryType } from '@/types';
export const useCachedQueries = (identifiers) => {
    const questionnaireCTX = useQuestionnaire();
    const prepareData = (responses) => {
        const initialAccumulator = {
            custom: {
                many: {},
                single: {}
            },
            normal: []
        };
        return responses.reduce((acc, { custom, normal }) => {
            var _a, _b;
            if (custom) {
                acc.custom.many = Object.assign(Object.assign({}, acc.custom.many), ((_a = custom.many) !== null && _a !== void 0 ? _a : {}));
                acc.custom.single = Object.assign(Object.assign({}, acc.custom.single), ((_b = custom.single) !== null && _b !== void 0 ? _b : {}));
            }
            if (normal) {
                acc.normal = [...acc.normal, ...normal];
            }
            return acc;
        }, initialAccumulator);
    };
    const handleCachedQueryRequests = (cachedQuery) => __awaiter(void 0, void 0, void 0, function* () {
        const { type } = cachedQuery;
        const { now_override } = identifiers, restIdentifiers = __rest(identifiers, ["now_override"]);
        const payload = Object.assign(Object.assign(Object.assign({}, restIdentifiers), (now_override && { now_override })), { query_key: cachedQuery.request_key });
        switch (type) {
            case CachedQueryType.CUSTOM_MANY: {
                const result = yield CaptureService.cachedQueryMany(payload);
                return {
                    custom: {
                        many: { [cachedQuery.result_cache_key]: result }
                    },
                    normal: []
                };
            }
            case CachedQueryType.CUSTOM_SINGLE: {
                const result = yield CaptureService.cachedQuerySingle(payload);
                return {
                    custom: {
                        single: { [cachedQuery.result_cache_key]: result }
                    },
                    normal: []
                };
            }
            default: {
                throw new Error(`${type} is an unsupported Cached Query`);
            }
        }
    });
    const handleCachedQueries = (cachedQueries = []) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            const promises = cachedQueries.map(handleCachedQueryRequests);
            const resultsArray = yield Promise.all(promises);
            const results = prepareData(resultsArray);
            questionnaireCTX.dispatch(setCachedQueryAnswer(results));
        }
        catch (error) {
            throw new Error(error);
        }
    });
    return {
        handleCachedQueries
    };
};
